module.exports = __webpack_public_path__ + "static/facebook-poster-a27bd282202805a8b49abcbc3bf2845a.png";